export default "<span [innerHTML]=\"msg\"></span>\n"